var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiners(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 24",
    width: 30,
    height: 24,
    role: "img",
    "aria-label": "Diners Club International",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.575 23.775C24.071 23.806 30 18.475 30 11.991 30 4.899 24.07-.002 17.575 0h-5.59C5.41-.002 0 4.9 0 11.99c0 6.487 5.41 11.816 11.985 11.785h5.59z",
    fill: "#0079BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.973.951C5.981.953 1.125 5.828 1.123 11.845c.002 6.016 4.858 10.89 10.85 10.893 5.994-.002 10.85-4.877 10.851-10.893 0-6.017-4.857-10.892-10.85-10.894zM5.096 11.845a6.915 6.915 0 014.415-6.444v12.886a6.912 6.912 0 01-4.415-6.442zm9.338 6.445V5.4a6.911 6.911 0 010 12.89z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiners);
export default __webpack_public_path__ + "static/media/diners.22230e5e8b7d993aa10e1d345f068e5c.svg";
export { ForwardRef as ReactComponent };